// extracted by mini-css-extract-plugin
export default {"page":"ProfilePage_page__02GZz"};